import { FieldTypeEnum } from "../../../enums/fieldTypeEnum";
import { AttachmentFieldItemForm } from "./fields/AttachmentFieldItemForm";
import { BooleanFieldItemForm } from "./fields/BooleanFieldItemForm";
import { DateFieldItemForm } from "./fields/DateFieldItemForm";
import { DatetimeFieldItemForm } from "./fields/DatetimeFieldItemForm";
import { DropdownFieldItemForm } from "./fields/DropdownFieldItemForm";
import { NumericFieldItemForm } from "./fields/NumericFieldItemForm";
import { RelationFieldItemForm } from "./fields/RelationFieldItemForm";
import { TextFieldItemForm } from "./fields/TextFieldItemForm";
import { TimeFieldItemForm } from "./fields/TimeFieldItemForm";
import { IdFieldItemForm } from "./fields/IdFieldItemForm";
import { ReferenceColumnFieldItemForm } from "./fields/ReferenceColumnFieldItemForm";

export const ItemFormPreview = ({ fields, entityId }) => {
    const canEdit = false;
    const handleChangeValue = () => { };
    const itemForm = {
        form: {},
        errors: {}
    };

    const getFormField = (field) => {
        switch (field.Type) {
            case FieldTypeEnum.Integer:
                return <NumericFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    isDecimalField={false}
                    isDisabled={!canEdit}
                    itemForm={itemForm} />;
            case FieldTypeEnum.Decimal:
                return <NumericFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    isDecimalField={true}
                    isDisabled={!canEdit}
                    itemForm={itemForm} />;
            case FieldTypeEnum.Boolean:
                return <BooleanFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    itemForm={itemForm}
                    isDisabled={!canEdit} />;
            case FieldTypeEnum.Text:
                return <TextFieldItemForm
                    key={field.FieldId}
                    field={field}
                    isDisabled={!canEdit}
                    changeValueCallback={handleChangeValue}
                    itemForm={itemForm} />;
            case FieldTypeEnum.Datetime:
                return <DatetimeFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    itemForm={itemForm}
                    isDisabled={!canEdit} />;
            case FieldTypeEnum.Date:
                return <DateFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    itemForm={itemForm}
                    isDisabled={!canEdit} />;
            case FieldTypeEnum.Time:
                return <TimeFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    itemForm={itemForm}
                    isDisabled={!canEdit} />;
            case FieldTypeEnum.Id:
                return <IdFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    itemForm={itemForm}
                    isDisabled={true} />;
            case FieldTypeEnum.Attachment:
                return <AttachmentFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    itemForm={itemForm}
                    isDisabled={!canEdit} />;
            case FieldTypeEnum.Currency:
                return <NumericFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    isDecimalField={true}
                    isDisabled={!canEdit}
                    itemForm={itemForm} />;
            case FieldTypeEnum.Dropdown:
                return <DropdownFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    itemForm={itemForm}
                    isDisabled={!canEdit} />;
            
            case FieldTypeEnum.ReferenceColumn:
                return <ReferenceColumnFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    itemForm={itemForm}
                    isDisabled={!canEdit}
                />;
            case FieldTypeEnum.Relation:
                return <RelationFieldItemForm
                    key={field.FieldId}
                    field={field}
                    changeValueCallback={handleChangeValue}
                    itemForm={itemForm}
                    isDisabled={!canEdit}
                />;
        }
    };

    return (
        <>
            <div className="item-form-grid">
                {fields?.map(f => {
                    return (
                        <div key={f.FieldId} style={{ display: "flex", gridColumnEnd: "span 2" }}>
                            {getFormField(f)}
                        </div>
                    );
                })}
            </div>
        </>
    );
};
